module.exports = __webpack_public_path__ + "static/media/select_segment_icon.62ad1697.svg";